import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Button } from '../../components/Button';

/**
 * Signs out and goes to a plain sign-in form. Navigating explicitly, and without state, matters:
 * left to itself `SignupSessionRoute` would send the signed-out page to `/login` with this page as
 * the return path, and the next person to sign in on this browser would land on payment.
 */
export const SignOutButton = () => {
  const { logout, loading } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const handleSignOut = async () => {
    setError('');
    try {
      await logout();
    } catch {
      setError('Failed to sign out. Please try again.');
      return;
    }
    navigate('/login', { replace: true, state: null });
  };

  return (
    <>
      {error && (
        <p className="signup-field-error" role="alert">
          {error}
        </p>
      )}
      <Button
        type="button"
        variant="secondary"
        fullWidth
        loading={loading}
        onClick={() => void handleSignOut()}
        data-testid="signup-sign-out"
      >
        Sign Out
      </Button>
    </>
  );
};
